import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { LayoutModule } from '@angular/cdk/layout';

import { DateAdapterModule, LibCoreLayoutModule } from '@libs/index';
import { RouterModule } from '@angular/router';
import { MatNativeDateModule } from '@angular/material/core';
import { ContentContainerComponent } from './components/content-container/content-container.component';
import { MoveToHeadDirective } from './directives/move-to-head.directive';
import { PipesModule } from '@libs/pipes';

@NgModule({
  declarations: [
    // components
    ContentContainerComponent,
    // directives
    MoveToHeadDirective,
  ],
  imports: [
    CommonModule,
    DateAdapterModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    LayoutModule,
    LibCoreLayoutModule,
    MatNativeDateModule,
    TranslateModule.forChild(),
  ],
  exports: [
    LibCoreLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    LayoutModule,
    TranslateModule,
    PipesModule,
    RouterModule,
    // components
    ContentContainerComponent,
    // directives
    MoveToHeadDirective,
  ],
})
export class CommonsModule {}
